import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Dueños de negocio que gestionan sus propios anuncios y están cansados de perder dinero.', 'Media Buyers que necesitan resultados consistentes para sus clientes en un entorno post-iOS14.', 'Coaches, Consultores y Dueños de E-commerce que buscan escalar a mercados internacionales (como USA) con eficiencia.', "Emprendedores prácticos que prefieren una estrategia sólida sobre 'trucos' temporales."];
  const notFor = ["Personas que buscan 'el botón mágico' de Facebook para hacerse ricos sin esfuerzo.", 'Anunciantes que no están dispuestos a invertir tiempo en crear buenos mensajes y creativos.', 'Quienes tienen miedo de dejar que la Inteligencia Artificial de Meta haga su trabajo de optimización.', "Agencias que prefieren vender reportes de 'likes' en lugar de conversiones reales."];
  return <section className="py-20 px-4 bg-[#0d1117]/50 border-y border-white/5" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-125">
          {/* Para quién ES */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#161b22] rounded-3xl p-8 md:p-10 border border-emerald-500/20" data-id="element-126">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-127">
              <div className="bg-emerald-500/20 p-2 rounded-full" data-id="element-128">
                <CheckIcon className="w-6 h-6 text-emerald-500" data-id="element-129" />
              </div>
              Para quién ES
            </h3>
            <ul className="space-y-6" data-id="element-130">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-131">
                  <CheckIcon className="w-6 h-6 text-emerald-500 shrink-0 mt-0.5" data-id="element-132" />
                  <span className="text-slate-300 leading-relaxed" data-id="element-133">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quién NO ES */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#161b22] rounded-3xl p-8 md:p-10 border border-red-500/20" data-id="element-134">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-135">
              <div className="bg-red-500/20 p-2 rounded-full" data-id="element-136">
                <XIcon className="w-6 h-6 text-red-500" data-id="element-137" />
              </div>
              Para quién NO ES
            </h3>
            <ul className="space-y-6" data-id="element-138">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-139">
                  <XIcon className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-140" />
                  <span className="text-slate-300 leading-relaxed" data-id="element-141">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}